module.exports = __webpack_public_path__ + "static/media/webecomm.7ec5d87f.png";